import {Component} from '@angular/core';
import {AlertController, NavParams} from 'ionic-angular';

import {GestaoPcaService} from '../../../../providers/gestao-pca-service';
import {ProcessosCorrelatosService} from '../../../../providers/processos-correlatos-service';

/*
  Generated class for the ModuloAnalise page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-pv-processos-correlatos',
  templateUrl: 'modal-pv-processos-correlatos.html',
  providers: [
    ProcessosCorrelatosService
  ]
})
export class ModalPreVisualizarProcessosCorrelatosPage {
  titulo: any;
  isJurisdicionado: any;
  listaProcessosCorrelatos: any[];
  processosCorrelatosDados: any;
  dataGeracao: any;
  loading: boolean = true;

  constructor(public navParams: NavParams,
    public processosCorrelatosService: ProcessosCorrelatosService,
    public alertCtrl: AlertController,
    public gestaoPcaService: GestaoPcaService) {

    this.processosCorrelatosDados = {
      anoExercicio: this.gestaoPcaService.getPCA().dsAnoexercicio,
      entidade: { numero: "1", nome: "" },
      numeroPCA: this.gestaoPcaService.getPCA().id,
      parecerAnalista: ""
    };

    this.dataGeracao = new Date();

    this.buscarNomeEntidade();
    this.listarProcessosCorrelatos();
  }

  buscarNomeEntidade() {
    this.processosCorrelatosService.buscarNomeEntidade("1").subscribe(data => this.processosCorrelatosDados.entidade.nome = data.nmEntidade, error => console.log("erro: " + error));
  }

  listarProcessosCorrelatos() {
    this.processosCorrelatosService.listarProcessos(this.processosCorrelatosDados.anoExercicio, this.processosCorrelatosDados.entidade.numero, this.processosCorrelatosDados.numeroPCA).subscribe(
      data => {
        let listaProcessosCorrelatosAux = [];
        data.listaProcessosCorrelatos.forEach(processoCorrelato => {
          if (processoCorrelato.flCertificado) {
            listaProcessosCorrelatosAux.push(processoCorrelato);
          }
        });
        this.processosCorrelatosDados.parecerAnalista = data.parecer;
        this.listaProcessosCorrelatos = listaProcessosCorrelatosAux;
        this.loading = false;
      }, error => {
        this.listaProcessosCorrelatos = [];
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/processos-correlatos/modal-pv-processos-correlatos.ts